var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.Progressbar),_c('div',{staticClass:"apps-auth-panel"},[(!_setup.error)?_c(_setup.Loader):_c('button',{staticClass:"btn btn-primary",on:{"click":_setup.getConfig}},[_vm._v(" "+_vm._s(_vm.$t("salesChannelManagementApp.authRetry"))+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }